// Tracking screen entry point. Does the initial booking fetch, then
// dispatches to either the new V2d driver UI or the legacy client UI
// based on the presence of `booking.driverJwt`:
//
//   - driverJwt truthy  → new driver V2d layout (TrackContentV2d)
//   - driverJwt falsy   → legacy client layout (TrackContent)
//
// We also hide the Voiceflow overlay while on any /track route so the
// widget doesn't sit on top of the driver CTA.

import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { useLocation, useParams } from "react-router-dom";

import { apiRoot } from "../../../index";
import LegacyTrackContent from "../content/trackContent";
import TrackContentV2d from "../content/track/TrackContent";

function Track() {
  const location = useLocation();
  const params = useParams();

  const [initialBooking, setInitialBooking] = useState(null);
  const [loadError, setLoadError] = useState(null);

  // Hide the Voiceflow overlay while on /track routes.
  useEffect(() => {
    const overlay = document.getElementById("VG_OVERLAY_CONTAINER");
    if (location.pathname.startsWith("/track") && overlay) {
      overlay.style.display = "none";
    }
    return () => {
      if (overlay) overlay.style.display = "block";
    };
  }, [location.pathname]);

  // One fetch at this level decides which UI to render.
  useEffect(() => {
    let cancelled = false;
    axios
      .get(
        apiRoot +
          "/api/v1/driverapp/track/" +
          params.uid +
          "/" +
          params.token
      )
      .then((res) => {
        if (!cancelled) setInitialBooking(res.data);
      })
      .catch((e) => {
        if (!cancelled) setLoadError(e?.response?.status || "unknown");
      });
    return () => {
      cancelled = true;
    };
  }, [params.uid, params.token]);

  if (loadError) {
    return (
      <CenteredShell>
        <h3>Lien invalide ou expiré</h3>
        <p>Contactez l'équipe Zeplan si le problème persiste.</p>
      </CenteredShell>
    );
  }

  if (!initialBooking) {
    return (
      <CenteredShell>
        <h3>Chargement…</h3>
      </CenteredShell>
    );
  }

  if (initialBooking.driverJwt) {
    return <TrackContentV2d initialBooking={initialBooking} />;
  }

  // Legacy client view — keep the original wrapper so its styling stays intact.
  return (
    <AppContainer>
      <ContentWrapper>
        <MainContent>
          <LegacyTrackContent />
        </MainContent>
      </ContentWrapper>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const MainContent = styled.div`
  flex: 1;
  overflow-y: auto;
  background-color: #f4f5f7;
  margin: 2rem 2rem 8rem 2rem;
  padding: 2rem;
  border-radius: 40px;
  transition: margin-left 0.3s ease;

  @media (max-width: 720px) {
    margin: 0 0 8rem 0;
    border-radius: 0;
  }
`;

const CenteredShell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 24px;
  text-align: center;
  color: #6b6a73;
`;

export default Track;
